/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { Header, SortByList, Buttons } from '../../components';

class SortBy extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Header title={t('filter.label.sort-by')} />
        <Divider />
        <SortByList />
        <Buttons />
      </React.Fragment>
    );
  }
}

SortBy.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SortBy);
